import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { ExprUtils } from '@/common/utils/ExprUtils';

export const AbvPbmRateForm = () => {

  const augFieldDefs = (fieldToFieldDef) => {
      fieldToFieldDef.prodId.expr = ExprUtils.whereParams('hierCode', 'PROD_HIER', 'isLeaf', true);
      fieldToFieldDef.channelId.expr = ExprUtils.whereParams('code', ['MCO', 'MPD'], 'hierCode', 'RESERVE_CHANNEL_HIER');
      fieldToFieldDef.pbmId.expr = ExprUtils.whereParams('hierCode', 'PBM_HIER', 'isLeaf', true);
  }
  
  return (
    <EntityForm augFieldDefs={augFieldDefs} />
  )
}